import { useTranslation } from 'react-i18next';
import { Container, Grid, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Section, PageHero, SectionTitle, ProductCard, AnimatedBox } from '../../components/ui';

const products = [
  {
    key: 'deenmatches',
    url: 'https://deenmatches.co.uk',
    image: '/images/products/deenmatches-icon.png',
  },
  {
    key: 'ubcconnect',
    url: 'https://ubc-connect.co.uk',
    image: '/images/products/ubc-connect-icon.png',
  },
  {
    key: 'suvaifoods',
    url: 'https://suvaifoods.co.uk/',
    image: '/images/products/suvai-foods-icon.png',
  },
  {
    key: 'watfordmosque',
    url: 'https://watfordmosque.nexfah.com',
    image: '/images/products/watford-mosque-icon.png',
  },
  {
    key: 'bookmoteasy',
    url: 'https://bookmoteasy.co.uk',
    image: '/images/products/bookmoteasy-icon.png',
  },
  {
    key: 'crux360',
    url: 'https://crux360.ai',
    image: '/images/products/crux360-icon.png',
  },
  {
    key: 'arimmigration',
    url: 'https://arimmigrationservices.co.uk/',
    image: '/images/products/ar-immigration-icon.svg',
  },
  {
    key: 'birminghamsleepcentre',
    url: 'https://birminghamsleepcentre.co.uk/',
    image: '/images/products/birmingham-sleep-centre-icon.svg',
  },
];

export default function Products() {
  const { t } = useTranslation();

  return (
    <>
      {/* Page Header */}
      <PageHero title={t('products.title')} subtitle={t('products.subtitle')} />

      {/* Products Grid */}
      <Section>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {products.map((product, index) => (
              <Grid item xs={12} md={4} key={product.key}>
                <AnimatedBox
                  animation="fadeInUp"
                  delay={`${index * 0.15}s`}
                  sx={{ height: '100%' }}
                >
                  <ProductCard
                    productKey={product.key}
                    title={t(`products.${product.key}.title`)}
                    description={t(`products.${product.key}.description`)}
                    features={t(`products.${product.key}.features`, { returnObjects: true })}
                    url={product.url}
                    image={product.image}
                  />
                </AnimatedBox>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  );
}
